import React, {Component} from "react";
import {NavLink} from 'react-router-dom';

class Menu extends Component {

    render() {
        const links = [];
        for (var i=0; i < this.props.pages.length; i++) {
            var page = this.props.pages[i];
            if(page.fields.external){
                links.push(<li key={i}><a href={this.props.pages[i].fields.path} target="_blank">{this.props.pages[i].fields.title}</a></li>);
            } else {
                links.push(<li key={i}><NavLink to={this.props.pages[i].fields.path}>{this.props.pages[i].fields.title}</NavLink></li>);
            }
        }

        return (

            <ul>
                {
                    links
                }
            </ul>
        )
    }
}

export default Menu


// WEBPACK FOOTER //
// ./src/components/content/menu/Menu.js